import React from "react";
import { connect } from "react-redux";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import DocumentDialogContent from "./ProveedorFirma";
import { Modal, Button } from "react-bootstrap";
import { getProveedoresFirmas } from "./ProveedorFirmaService";
import ProveedorFirmaDatos from "./ProveedorFirmaDatos";
import Navbar from '../home/Navbar';
import visibility from '../../styles/icons/visibility.svg';
import editIcon from '../../styles/icons/edit.svg'
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import ModalDetalleConfiguraciones from "../componentes/modales/ModalDetalleConfiguraciones";


class ProveedoresFirma extends React.Component {

  constructor(props) {
    super(props);
    const { location } = this.props;
    const estado = location && location.state ? location.state : {};
    this.state = {
      dialogTitle: "Registrar nuevo proveedor de firma",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedProveedor: {
        id: "",
        clientSecret: "",
        clientId: "",
        descripcion: "",
        schema: "",
        host: "",
        port: "",
        activo: true,
      },
      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      loading: true,
      pageSize: 10,
      search: "",
      mensajeFlash: estado.mensajeFlash || "",
      mostrarMensajeFlash: estado.mostrarMensajeFlash || false,
      mensajeFlashSeverity: estado.mensajeFlashSeverity || "neutral",
    }
    this.tableRef = React.createRef();
    this.modalRef = React.createRef();
  }

  handleDialog = (value, mensaje = "") => {
    if (value === false) {
      this.fetchProveedores(0, this.state.pageSize, "");
      if (mensaje != "") {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: mensaje
        });
      }
    }
    this.setState({ dialogIsOpen: value });
  };


  handleDialogVerDatos = (value, psaSeleccionado = null) => {
    this.setState({ dialogIsOpenVerDatos: value }, () => {
      if (value && psaSeleccionado && this.modalRef) {
        this.modalRef.current.cargarDetalles(psaSeleccionado);
      }
    });
  };

  handleNewProveedor = () => {
    this.props.history.push('/admin/proveedores-firma/accion/add')
  };

  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchProveedores(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchProveedores(0, this.state.pageSize, "");
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchProveedores(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchProveedores(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchProveedores(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getProveedoresFirmas(page, pageSize, search).then(() => {
      this.setState({
        proveedores: this.props.proveedorData.proveedores,
        page: this.props.proveedorData.page,
        totalCount: this.props.proveedorData.totalCount,
        totalPages: Math.ceil(
          this.props.proveedorData.totalCount / pageSize
        ),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchProveedores(0, this.state.pageSize, this.state.search);
    });
  };
  render() {
    return (
      <div>
          <header className="component-header">
            <div className="page-container">
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">Proveedores de Firma Digital</h1>
                  <p className="page-description">
                    Desde este menú puede gestionar los proveedores habilitados
                  </p>
                </div>
                <div className="head-actions">
                  <button onClick={this.handleNewProveedor} className="btn-medium btn-primary">
                    <span className="material-symbols-outlined">add</span> Nuevo Proveedor
                  </button>
                </div>
              </div>
            </div>
          </header>

          <div className="wrapperContent">
            <div className="page-container">
              {/*


              <MensajeFlash
                mensaje={this.state.mensajeFlash}
                severity="success"
                open={this.state.mostrarMensajeFlash}
                handleClose={this.handleCloseMensajeFlash}
              />

              <Modal size="lg" centered show={this.state.dialogIsOpen} onHide={this.handleDialog} backdrop="static" keyboard={false}>
                <DocumentDialogContent
                  proveedor={this.state.selectedProveedor}
                  handleClose={this.handleDialog}
                  type={this.state.dialogType}
                  submitText={this.state.submitText}
                  disabledInput={this.state.disabledInput}
                  dialogTitle={this.state.dialogTitle}
                />
              </Modal>

              <Modal size="lg" centered show={this.state.dialogIsOpenVerDatos} onHide={this.handleDialogVerDatos} backdrop="static" keyboard={false}>
                <ProveedorFirmaDatos
                  proveedor={this.state.selectedProveedor}
                  handleClose={this.handleDialogVerDatos}
                  type={this.state.dialogType}
                  submitText={this.state.submitText}
                  disabledInput={this.state.disabledInput}
                  dialogTitle={this.state.dialogTitle}
                />
              </Modal>
*/}
              <div className="component-table">
                <div className="component-pagination">
                  <div className="pagination-actions">
                    <form className="search-form form" onSubmit={(e) => e.preventDefault()}>
                      <div className="search-group">
                        <div className="input-icon">
                          <span className="material-symbols-outlined">search</span>
                        </div>
                        <input
                          type="search"
                          className="input-search"
                          placeholder="Buscar..."
                          value={this.state.search}
                          onChange={this.handleSearchChange}
                        />
                      </div>
                    </form>

                    <div className="pagination">
                      <span className="info-pages">
                        {this.state.totalCount === 0
                          ? "0"
                          : this.state.page * this.state.pageSize + 1}
                        -
                        {Math.min((this.state.page + 1) * this.state.pageSize, this.state.totalCount)} de {this.state.totalCount}
                      </span>
                      <button
                        className={`btn-prev ${this.state.page === 0 ? "btn-disabled" : ""}`}
                        onClick={() => this.handlePageChange(this.state.page - 1)}
                        disabled={this.state.page === 0}
                      >
                        <span className="material-symbols-outlined">navigate_before</span>
                      </button>
                      <button
                        className={`btn-next ${this.state.page >= this.state.totalPages - 1 ? "btn-disabled" : ""}`}
                        onClick={() => this.handlePageChange(this.state.page + 1)}
                        disabled={this.state.page >= this.state.totalPages - 1}
                      >
                        <span className="material-symbols-outlined">navigate_next</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="responsive-table">
                  {this.state.loading ? (
                    <div className="loading-area"><p>Cargando...</p></div>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th>Cliente ID</th>
                          <th>Descripción</th>
                          <th>Estado</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.proveedorData.proveedores.length === 0 ? (
                          <tr>
                            <td colSpan="4">No se encontraron resultados</td>
                          </tr>
                        ) : (
                          this.props.proveedorData.proveedores.map((proveedor, index) => (
                            <tr key={index}>
                              <td>{proveedor.clientId}</td>
                              <td>{proveedor.descripcion}</td>
                              <td>{proveedor.activo ? "Activo" : "Inactivo"}</td>
                              <td>
                                <div className="table-actions">
                                  <button className="table-icon" onClick={() =>
                                    this.props.history.push({
                                      pathname: '/admin/proveedores-firma/accion/edit',
                                      state: {
                                        proveedor: proveedor
                                      }
                                    })
                                  }>
                                    <img src={editIcon} alt="editar" />
                                  </button>

                                  <button className="table-icon" onClick={() => {this.handleDialogVerDatos(true, proveedor)}}>
                                    <img src={visibility} alt="ver" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ModalDetalleConfiguraciones
            ref={this.modalRef}
            abierto={this.state.dialogIsOpenVerDatos}
            onClose={() => this.handleDialogVerDatos(false)}
            titulo="Datos del Proveedor"
            renderContenido={(datos) => (
              <div className="card">
                <p className="section__subtitle">
                  {" "}
                  {datos.descripcion?.trim() || "--"}{" "}
                </p>

                <div className="card-content">
                  <div className="content-inner">
                    <span className="label"> Client ID </span>
                    <span className="txt">
                      {" "}
                      {datos.clientId?.trim() || "--"}{" "}
                    </span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Client Secret </span>
                    <span className="txt">{datos.clientSecret?.trim() || "--"}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Esquema </span>
                    <span className="txt">{datos.schema?.trim() || "--"}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Host </span>
                    <span className="txt">{datos.host?.trim() || "--"}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Puerto </span>
                    <span className="txt">{datos.port?.trim() || "--"}</span>
                  </div>
                  <div className="content-inner">
                    <span className="label"> Estado </span>
                    <div className="row__labels">
                      {
                        datos.activo
                          ? (<span className="label__success"> Activo </span>)
                          : (<span className="label__warning"> Inactivo </span>)
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          />
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />
      </div>
    );
  }

}

const mapDispatchToProps = (dispatch) => ({
  getProveedoresFirmas: (page, size, search) => dispatch(getProveedoresFirmas(page, size, search)),
});

const mapStateToProps = (state) => ({
  proveedorData: state.proveedoresData
});

export default connect(mapStateToProps, mapDispatchToProps)(ProveedoresFirma);